import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function CoreGuard({ children }) {

  const { user, initialized, hasActiveSubscription } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {

    if (!initialized) return;

    // 🔒 No usuario → login
    if (!user) {
      navigate("/login");
      return;
    }

    // 🧠 ADMIN / STAFF → acceso total
    if (user.role === "ADMIN" || user.role === "STAFF") {
      return;
    }

    // 🔒 Usuario sin suscripción → mostramos pantalla amable.
// No redirigimos automático a Store.
}, [initialized, user, hasActiveSubscription, navigate]);

  // 🧠 Mientras carga contexto → no render
  if (!initialized) return null;

  // 🔒 Sin usuario → no render
  if (!user) return null;

  // 🧠 ADMIN / STAFF → SIEMPRE render
if (user.role === "ADMIN" || user.role === "STAFF") {
  return children;
}

// 🔒 Usuario sin suscripción → pantalla amable
if (!hasActiveSubscription) {
  return (
    <main className="z-access-paused-shell">
      <section className="z-access-paused-card">
        <div className="z-access-paused-kicker">
          Membresía pausada
        </div>

        <h1 className="z-access-paused-title">
          ¡No detengas tu evolución en ZEDRO!
        </h1>

        <p className="z-access-paused-copy">
          Tu membresía ha expirado, pero tu historial está 100% a salvo.
          Puedes retomar tu formación en cualquier momento sin perder ni un solo paso de tu avance.
        </p>

        <p className="z-access-paused-note">
          ZEDRO está diseñado para acompañarte paso a paso, con orden, constancia y profundidad.
        </p>

        <div className="z-access-paused-actions">
          <button
            type="button"
            className="z-access-paused-primary"
            onClick={() => navigate("/store")}
          >
            Reactivar mi membresía
          </button>
        </div>
              </section>
            </main>
          );
        }

// ✅ Acceso permitido
return children;
}